var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"customer-case"},[_c('div',{staticClass:"title"},[_vm._v("客户案例")]),_c('div',{staticClass:"customer-case-box",style:({backgroundImage: `url(${_vm.info.customerCaseImg})`})},[_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.info.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }